var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStyle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.07 3.98L22.03 15.95C22.45 16.96 21.96 18.13 20.94 18.55L13.58 21.6C13.33 21.7 13.07 21.75 12.81 21.75C12.03 21.74 11.29 21.28 10.98 20.52L6.01998 8.55C5.90998 8.29 5.85998 8.02 5.86998 7.75C5.88998 6.98 6.34998 6.26 7.09998 5.95L14.47 2.9C14.73 2.79 15 2.75 15.26 2.75C16.03 2.77 16.76 3.23 17.07 3.98ZM3.86998 20.21L2.52998 19.65C1.51998 19.23 1.02998 18.06 1.43998 17.04L3.86998 11.18V20.21ZM7.87998 8.75C7.32998 8.75 6.87998 8.3 6.87998 7.75C6.87998 7.2 7.32998 6.75 7.87998 6.75C8.42998 6.75 8.87998 7.2 8.87998 7.75C8.87998 8.3 8.42998 8.75 7.87998 8.75ZM7.87998 21.75C6.77998 21.75 5.87998 20.85 5.87998 19.75V13.41L9.32998 21.75H7.87998Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle);
export default __webpack_public_path__ + "static/media/style.c3690ef33e1c4dd353169fab36e56bd7.svg";
export { ForwardRef as ReactComponent };